import { EDIT_KEYS } from '../common/advanced-editor/constants';

export const PHOTO_ATTRIBUTES = [
  ...EDIT_KEYS,
  'saturation',
  'colour_fx',
  'quantity',
];
